export default __webpack_public_path__ + "static/media/i.93990523.svg";